// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__7SUcp","inputWrap":"CustomTip_inputWrap__YEhty"};